import React, { useState } from 'react';
import {
  Grid, IconButton, Tooltip, Button, Chip, Stack, Badge, Menu, MenuItem, ListItemIcon, ListItemText, Divider,
} from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ChatIcon from '@mui/icons-material/Chat';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import ReplyIcon from '@mui/icons-material/Reply';
import StopIcon from '@mui/icons-material/Stop';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import BlockIcon from '@mui/icons-material/Block';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import '../chat/styles.css';

// GRUPO — header ESPELHADO do header 1:1 (mesmas classes CSS + botoes de acao equivalentes),
// com dados/acoes de grupo. As acoes 1:1 (criar chamado / transferir / finalizar) estao
// REPRESENTADAS (comportamento mock nesta fase). Cor primaria via CSS var whitelabel.
const btnSx = {
  minWidth: 0, color: '#000', textTransform: 'none', border: '1px solid rgba(0,0,0,.4)',
  '& .MuiButton-startIcon': { marginRight: 0, marginLeft: 0 },
};

function GroupHeader(props) {
  const {
    intl, chat, groupName, memberCount, joinReqCount, isSuspended, inviteLink,
    onOpenParticipants, onOpenJoinRequests, onReset, onDelete, onCopyLink, onMock,
  } = props;
  const t = (id, v) => intl.formatMessage({ id }, v);
  const [menu, setMenu] = useState(null);
  const providerId = chat?.messageproviderid;

  const providerIcon = (
    <>
      {(providerId == 2) && <WhatsAppIcon sx={{ color: '#59BC6B', fontSize: 22 }} />}
      {(providerId == 6) && <ChatIcon sx={{ color: '#277afe', fontSize: 22 }} />}
    </>
  );

  return (
    <div className="omnichannel-chat-header">
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <div className={props.isMobile ? 'omnichannel-chat-header-chat-info-root-mobile' : 'omnichannel-chat-header-chat-info-root'}>
            <div className="omnichannel-chat-header-chat-info" style={{ width: '100%' }}>
              <GroupsIcon className="omnichannel-chat-header-chat-info-icon"
                sx={{ width: '50px', height: '50px', color: 'var(--mexx-green-primary, #8BC34A)' }} />
              &nbsp;<span style={{ fontWeight: 600 }}>{groupName}</span>&nbsp;
              <Stack sx={{ marginRight: '8px' }} direction="row" spacing={1} alignItems="center">
                <Chip label={'Id: #' + (chat?.id ?? '-')} sx={{ borderRadius: '4px' }} color="primary" />
                {providerId ? <span style={{ display: 'inline-flex', alignItems: 'center' }}>{providerIcon}</span> : null}
                <Chip icon={<PeopleAltIcon />} label={t('groupconv.membercount', { count: memberCount })}
                  variant="outlined" sx={{ borderRadius: '4px' }} />
                {isSuspended && (
                  <Chip icon={<BlockIcon />} label={t('groupconv.suspended')}
                    sx={{ borderRadius: '4px', bgcolor: '#ffebee', color: '#c62828', fontWeight: 600, '& .MuiChip-icon': { color: '#c62828' } }} />
                )}
              </Stack>
            </div>
          </div>
        </Grid>

        <Grid item xs={12} className="omnichannel-chat-header-attendance-info">
          {/* status (representado) */}
          <div className="omnichannel-chat-header-attendance-info-container" style={{ width: '30%' }}>
            <Chip label={t('groupconv.status.inprogress')} color="primary" variant="outlined"
              sx={{ borderRadius: '4px', fontWeight: 600 }} />
          </div>

          {/* responsavel */}
          <div className="omnichannel-chat-header-attendance-info-container" style={{ width: '100%' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, minWidth: 0 }}>
              <SupportAgentIcon style={{ fontSize: 18, color: '#90a4ae', flexShrink: 0 }} />
              {!props.isMobile && <span style={{ fontSize: 12, color: '#b0bcc4', fontWeight: 500, flexShrink: 0 }}>{t('groupconv.assignee')}:</span>}
              <span style={{ fontSize: 13, color: '#607d8b', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {chat?.assignedusername || '—'}
              </span>
            </div>
          </div>

          {/* acoes */}
          <div className="omnichannel-chat-header-attendance-info-buttons-container">
            {/* GRUPO: participantes + solicitacoes */}
            <Tooltip title={t('groupconv.menu.participants')} arrow>
              <Button onClick={onOpenParticipants} variant="text" sx={{ ...btnSx, marginRight: '15px' }}
                startIcon={<PeopleAltIcon sx={{ color: 'var(--mexx-green-primary, #8BC34A)' }} />} />
            </Tooltip>
            <Tooltip title={t('groupconv.menu.joinrequests')} arrow>
              <Button onClick={onOpenJoinRequests} variant="text" sx={{ ...btnSx, marginRight: '15px' }}
                startIcon={<Badge badgeContent={joinReqCount} color="warning"><HowToRegIcon sx={{ color: '#277afe' }} /></Badge>} />
            </Tooltip>

            {/* 1:1 espelhadas (representadas, mock) */}
            <Tooltip title={t('create.called')} arrow>
              <Button onClick={() => onMock(t('groupconv.mock.called'))} variant="text" sx={{ ...btnSx, marginRight: '15px' }}
                startIcon={<ConfirmationNumberIcon sx={{ color: '#277afe' }} />} />
            </Tooltip>
            <Tooltip title={t('groupconv.transfer')} arrow>
              <Button onClick={() => onMock(t('groupconv.mock.transfer'))} variant="text" sx={{ ...btnSx, marginRight: '15px' }}
                startIcon={<ReplyIcon sx={{ color: '#32B847', transform: 'rotate(180deg)' }} />} />
            </Tooltip>
            <Tooltip title={t('groupconv.finish')} arrow>
              <Button onClick={() => onMock(t('groupconv.mock.finish'))} variant="text" sx={{ ...btnSx, marginRight: '15px' }}
                startIcon={<StopIcon sx={{ color: '#CE1B1B' }} />} />
            </Tooltip>

            {/* kebab: link/reset/excluir */}
            <Tooltip title={t('groupconv.more')} arrow>
              <Button onClick={(e) => setMenu(e.currentTarget)} variant="text" sx={btnSx}
                startIcon={<MoreVertIcon sx={{ color: '#000' }} />} />
            </Tooltip>
            <Menu anchorEl={menu} open={Boolean(menu)} onClose={() => setMenu(null)}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
              {inviteLink && (
                <MenuItem onClick={() => { setMenu(null); onCopyLink(); }}>
                  <ListItemIcon><ContentCopyIcon fontSize="small" /></ListItemIcon>
                  <ListItemText>{t('groupconv.copylink')}</ListItemText>
                </MenuItem>
              )}
              <MenuItem onClick={() => { setMenu(null); onReset(); }}>
                <ListItemIcon><AutorenewIcon fontSize="small" /></ListItemIcon>
                <ListItemText>{t('groupconv.menu.resetinvite')}</ListItemText>
              </MenuItem>
              <Divider />
              <MenuItem onClick={() => { setMenu(null); onDelete(); }} sx={{ color: '#c62828' }}>
                <ListItemIcon><DeleteOutlineIcon fontSize="small" sx={{ color: '#c62828' }} /></ListItemIcon>
                <ListItemText>{t('groupconv.menu.delete')}</ListItemText>
              </MenuItem>
            </Menu>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default GroupHeader;
